import React from 'react';
export function Footer() {
  return <footer className="bg-[#2D2D2D] text-white py-12 px-4" data-id="element-24">
      <div className="max-w-4xl mx-auto text-center" data-id="element-25">
        <div className="mb-8 p-4 bg-white/5 rounded-lg text-sm text-gray-400 max-w-2xl mx-auto" data-id="element-26">
          <p className="font-medium mb-1 text-white" data-id="element-27">AVISO LEGAL</p>
          <p data-id="element-28">Este producto es informativo. No sustituye terapia profesional.</p>
        </div>

        <p className="text-sm text-gray-500" data-id="element-29">
          © 2026 Plan NoMásTóxicos™. Todos los derechos reservados.
        </p>
      </div>
    </footer>;
}